<rt-dropdown>
  <rt-form-field
    *ngIf="searchEnabled"
    padding-lr-small-x
    padding-top-small-x
    variant="underlined search"
  >
    <rt-icon name="search"></rt-icon>
    <rt-input
      [autoFocus]="true"
      [formControl]="searchFormControl"
      placeholder="Search..."
      variant="underlined"
    ></rt-input>
  </rt-form-field>
  <div
    #virtualScrollerComponent
    (vsChange)="onChange($event)"
    (vsUpdate)="listUpdate($event)"
    [bufferAmount]="10"
    [enableUnequalChildrenSizes]="true"
    [executeRefreshOutsideAngularZone]="true"
    [items]="filteredEmojis"
    [style.height.px]="searchEnabled ? 244 : 288"
    [scrollDebounceTime]="30"
    [style.overflow-y]="isScrollAlwaysVisible ? 'scroll' : 'auto'"
    class="emoji-container"
    virtualScroller
  >
    <div
      *ngFor="let element of virtualScrollData; trackBy: trackByValue; let indexRow = index"
      [class.emoji-row]="FlatArrayItemType.EmojiRow === element.type"
      [class.heading-row]="FlatArrayItemType.Heading === element.type"
    >
      <rt-heading
        *ngIf="FlatArrayItemType.Heading === element.type"
        variant="uppercased subheading"
      >
        {{ element.name | translate }}
      </rt-heading>
      <ng-container *ngIf="FlatArrayItemType.EmojiRow === element.type">
        <span
          (click)="select(emoji)"
          (mouseenter)="onMouseEnter(indexRow + startIndexWithBuffer, indexCol)"
          *ngFor="let emoji of element.data; trackBy: trackByName; let indexCol = index"
          [class.active]="indexRow + startIndexWithBuffer === activeRow && indexCol === activeCol"
          title=":{{ emoji.shortName }}:"
          class="emoji-container"
        >
          <rt-emoji [emoji]="emoji.symbol" [size]="24"></rt-emoji>
        </span>
      </ng-container>
    </div>
  </div>
</rt-dropdown>
